import React, { Component } from "react";
import {
  Searchbar,
  GrantsSearchContainer,
  HiddenFrequency,
  GrantSearchLabel
} from "./style";
import MultiSelect from "./Select";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

class GrantSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      frequency: [],
      status: [],
      reStatus: [],
      yearly: [],
      options: this.props.options
    };
    this.handleStatus = this.handleStatus.bind(this);
    this.handleYearly = this.handleYearly.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleFrequency = this.handleFrequency.bind(this);
  }

  componentDidMount() {
    this.setState({ options: this.props.options });
  }

  handleStatus = value => {
    this.setState({ status: [...value] }, () => this.handleFilter(this.state));
  };
  handleReStatus = reStatus => {
    this.setState({ reStatus: [...reStatus] }, () =>
      this.handleFilter(this.state)
    );
  };

  handleFrequency = value => {
    let isRecurring = this.props.activeTab === "2" ? true : false;
    this.setState({ frequency: value }, () =>
      this.handleFilter(this.state, false, isRecurring)
    );
  };

  handleYearly = value => {
    this.setState({ yearly: value }, () => {
      let isOneTime = this.props.activeTab === "1" ? true : false;
      let isRecurring = this.props.activeTab === "2" ? true : false;
      this.handleFilter(this.state, isOneTime, isRecurring);
    });
  };

  handleFilter = (value, isOneTime = false, isRecurring = false) => {
    this.props.handleSearch(value, isOneTime, isRecurring);
  };

  render() {
    const { options } = this.state;
    const { oneTimeStatus, recurringStatus, filteredData } = this.props;
    return (
      <GrantsSearchContainer>
        <Searchbar>
          <GrantSearchLabel>Status</GrantSearchLabel>
          {options && options.recurringGrantFilters ? (
            <MultiSelect
              options={
                recurringStatus.length > 0
                  ? recurringStatus
                  : options.recurringGrantFilters
              }
              handleDropper={this.handleReStatus}
              placeholder={"-Select-"}
              menu={
                recurringStatus.length > 0
                  ? recurringStatus
                  : options.recurringGrantFilters
              }
            />
          ) : (
            <MultiSelect
              options={
                oneTimeStatus.length > 0
                  ? oneTimeStatus
                  : options.statusGrantFilters
              }
              handleDropper={this.handleStatus}
              placeholder={"-Select-"}
              menu={
                oneTimeStatus.length > 0
                  ? oneTimeStatus
                  : options.statusGrantFilters
              }
            />
          )}
          <GrantSearchLabel>Year</GrantSearchLabel>
          <MultiSelect
            options={options.yearlyGrantFilters}
            placeholder={"-Select-"}
            handleDropper={this.handleYearly}
            menu={options.YearlyGrantFilters}
          />

          {options && options.frequencyGrantFilters ? (
            <div style={{ display: "flex" }}>
              <GrantSearchLabel>Frequency</GrantSearchLabel>
              <MultiSelect
                options={options.frequencyGrantFilters}
                placeholder={"-Select-"}
                handleDropper={this.handleFrequency}
                menu={options.frequencyGrantFilters}
              />
            </div>
          ) : (
            <HiddenFrequency>
              <MultiSelect />
            </HiddenFrequency>
          )}
        </Searchbar>
      </GrantsSearchContainer>
    );
  }
}
GrantSearch.propTypes = {
  updatedMenu: PropTypes.any,
  filteredSearch: PropTypes.object,
  handleSearch: PropTypes.func,
  options: PropTypes.any,
  menu: PropTypes.array,
  oneTimeStatus: PropTypes.array,
  recurringStatus: PropTypes.array,
  filteredData: PropTypes.array,
  isFilterUsed: PropTypes.bool
};

const mapStateToProps = state => ({
  updatedMenu: state.getIn(["grantsActivityReducer", "menu"])
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GrantSearch);
